import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "../../atoms/RTCC/button"
import { Label } from "../../atoms/RTCC/label"

export const Detail = (props) => {
    const { plan, onClickPopup } = props;

    useEffect(() => {
        console.log(plan);
    })

    const history = useHistory();
    const next = () => {
        history.push("/reservationInput");
    };
    return (
        <div>
            <div className="detailLabel">
                <Label label={plan.overview} />
            </div>
            <div className="detailText">
                <Label label={plan.message} />
            </div>
        </div>
    );
};
